import { useAdminDashboard } from '../lib/admin'

export default function AdminDashboard() {
  const { data, isLoading, error } = useAdminDashboard()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-[var(--color-brand-200)] border-t-[var(--color-brand-500)]" />
      </div>
    )
  }

  if (error) {
    return <p className="text-[var(--color-danger)]">Erro ao carregar dashboard</p>
  }

  const stats = data ?? { total_users: 0, pending_count: 0, approved_count: 0, rejected_count: 0 }

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-[var(--color-text)]">Visão Geral</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <DashboardCard
          title="Total de Usuários"
          value={stats.total_users}
          icon={<PeopleIcon />}
        />
        <DashboardCard
          title="Pendentes"
          value={stats.pending_count}
          icon={<ClockIcon />}
          accent="var(--color-warning-500)"
        />
        <DashboardCard
          title="Aprovados"
          value={stats.approved_count}
          icon={<CheckIcon />}
          accent="var(--color-success-500)"
        />
        <DashboardCard
          title="Rejeitados"
          value={stats.rejected_count}
          icon={<XIcon />}
          accent="var(--color-danger-500)"
        />
      </div>
    </div>
  )
}

function DashboardCard({ title, value, icon, accent }: {
  title: string
  value: number
  icon: React.ReactNode
  accent?: string
}) {
  return (
    <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-4 shadow-sm">
      <div className="flex items-center gap-2">
        {icon}
        <p className="text-sm font-medium text-[var(--color-text-muted)]">{title}</p>
      </div>
      <p className={`mt-2 text-2xl font-bold ${accent ? `text-[${accent}]` : 'text-[var(--color-text)]'}`}>
        {value}
      </p>
    </div>
  )
}

function PeopleIcon() {
  return (
    <svg className="w-5 h-5 text-[var(--color-text-muted)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.106a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
    </svg>
  )
}

function ClockIcon() {
  return (
    <svg className="w-5 h-5 text-[var(--color-warning-500)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  )
}

function CheckIcon() {
  return (
    <svg className="w-5 h-5 text-[var(--color-success-500)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  )
}

function XIcon() {
  return (
    <svg className="w-5 h-5 text-[var(--color-danger-500)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  )
}
